module.exports = "//d274d294w9cx2v.cloudfront.net/a12316576fcc249a020dbd7f2132a0ff59c92eac/images/registryDefaultSmall.webp";